<template>
    <div id="shop">
        <template v-if="app.template.type === '92fanli'">
            <NTfanliShop
                    :title="title"
                    :style-name="app.template.style"
                    :list="shopData.list"
                    v-on:loadMore="fetchTopShopList"
            />
            <NTfanliBottomBar :style-name="app.template.style" />
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <DamaiShop
                    :title="title"
                    :style-name="app.template.style"
                    :list="shopData.list"
                    v-on:loadMore="fetchTopShopList"
            />
            <DamaiBottomBar :style-name="app.template.style" />
        </template>
        <template v-else>
            <IfanliShop
                    :title="title"
                    :style-name="app.template.style"
                    :list="shopData.list"
                    v-on:loadMore="fetchTopShopList"
            />
            <IfanliBottomBar :style-name="app.template.style" />
        </template>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    import IfanliShop from './ifanli/Shop';
    import NTfanliShop from './92fanli/Shop';
    import DamaiShop from './damai/Shop';
    import IfanliBottomBar from './ifanli/BottomBar';
    import NTfanliBottomBar from './92fanli/BottomBar';
    import DamaiBottomBar from './damai/BottomBar';
    import {appService} from "../services/app";
    import {config} from "../libs/config";
    import {isMobile} from "../libs/utils";

    export default {
        components: {
            IfanliShop,
            NTfanliShop,
            DamaiShop,
            IfanliBottomBar,
            NTfanliBottomBar,
            DamaiBottomBar
        },
        data() {
            return {
                title: '精选店铺',
                shopData: {
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 1
                },
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin;
            }

            this.fetchTopShopList({init: true});
        },
        mounted() {
            this.setBottomBarIndex(1);
        },
        watch: {
            '$route'(param) {
                if (param.name === 'shop') {
                    this.setBottomBarIndex(1);
                }
            }
        },
        methods: {
            ...mapMutations([
                'setBottomBarIndex'
            ]),
            fetchTopShopList: function ({init = false} = {}) {
                let self = this;

                if (self.shopData.isMore === true && self.shopData.loading === false) {
                    self.shopData.loading = true;

                    appService.fetchTopShopList({
                        pageNum: self.shopData.pageNum,
                        pageSize: config.PAGE_SIZE
                    }).then((res) => {
                        let {code, data: {list}} = res;
                        if (code === 200) {
                            if (list !== null && list.length > 0) {
                                if (init) {
                                    self.shopData.list = list;
                                } else {
                                    for (let i = 0; i < list.length; i++) {
                                        self.goodsData.list.push(list[i]);
                                    }
                                }

                                self.shopData.isMore = true;
                                self.shopData.pageNum++;
                            } else {
                                self.shopData.isMore = false;
                            }
                        }
                        self.shopData.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
